import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { TimerModule } from '../timers/timer.module';

@Component({
    selector: 'ms-scoreboard-time',
    templateUrl: 'scoreboard-time.html',
    styleUrl: './scoreboard-time.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, TimerModule, IconCustomComponent],
})
export class ScoreboardTimeComponent {
    @Input() event: EventModel;
    @Input() showStream = false;

    constructor(public sitecore: Sitecore) {}
}
